<template>
    <div class="main">
        <MyHeader index="1"></MyHeader>
        <div class="title">
           
            <div class="container" v-if=" this.$i18n.locale == 'zh_CN'">
                <h2>关于我们</h2>
                <h3>About Us</h3>
            </div>
            <div class="container" v-if=" this.$i18n.locale == 'en_US'">
                <h2>About Us</h2>
                <h3>关于我们</h3>
            </div>
        </div>
        <div class="aboutUsInfo">
            <div class="container">
                <div class="content">
                    <div class="leftMenu">
                         <ul>
                            <li>
                                <router-link to="/aboutUs">
                                    <i>{{$t('ccapp.tit')}}</i>
                                    <b></b>
                                </router-link>
                            </li>
                            <li class="on">
                                <router-link to="frame">
                                    <i>{{$t('ccapp.tit1')}}</i>
                                    <b></b>
                                </router-link>
                                <ul class="second " style="margin-top: 10px" >
                                    <li>
                                        <router-link :to="{name:'figure',params:{id:1}}">
                                            <i>{{$t('ccapp.tit2')}}</i>
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link :to="{name:'figure',params:{id:2}}">
                                            <i>{{$t('ccapp.tit3')}}</i>
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link :to="{name:'figure',params:{id:3}}">
                                            <i>{{$t('ccapp.tit4')}}</i>
                                        </router-link>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <router-link to="job">
                                    <i>{{$t('ccapp.tit5')}}</i>
                                    <b></b>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="rightContent">
                        <ul class="frameList">
                            <li>
                                <router-link :to="{name:'figure',params:{id:1}}">
                                    <div>
                                        <h4>{{$t('council.tit')}}</h4>
                                        <h5>{{$t('council.txt')}}</h5>
                                        <h5>{{$t('council.text')}}</h5>
                                        <h5 v-if=" this.$i18n.locale == 'en_US'">{{$t('council.text01')}}</h5>
                                    </div>
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{name:'figure',params:{id:2}}">
                                    <div>
                                        <h4>{{$t('council.tit1')}}</h4>
                                        <h5>{{$t('council.txt1')}}</h5>
                                        <h5>{{$t('council.text1')}}</h5>
                                    </div>
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{name:'figure',params:{id:3}}">
                                    <div>
                                        <h4>{{$t('council.tit2')}}</h4>
                                        <h5>{{$t('council.txt2')}}</h5>
                                    </div>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <MyFooter></MyFooter>
    </div>
</template>

<script>
    import MyHeader from './common/MyHeader';
    import MyFooter from './common/MyFooter';
    export default {
        name: "FramePage",
        components: { MyHeader,MyFooter },
    }
</script>

<style lang="scss" scoped>
    .main{
        .title{
            height:380px;
            background: url("./image/aboutUsImg.jpg") no-repeat center center;
            background-size: cover;
            .container{
                h2{
                    padding-top: 180px;
                    text-align: center;
                    color: #304656;
                    height:42px;
                    font-size:32px;
                    font-weight:bold;
                    line-height:42px;
                }
                h3{
                    text-align: center;
                    height:29px;
                    font-size:22px;
                    line-height:29px;
                    color: #304656;
                }
            }
        }
        .aboutUsInfo{
            .container{
                border-top: 1px solid #E6E6E6;
                .content{
                    margin-top: 66px;
                    overflow: hidden;
                    margin-bottom: 48px;
                    .leftMenu{
                        width: 246px;
                        float: left;
                        ul{
                            li{
                                line-height: 36px;
                                margin-bottom: 10px;
                                &:last-child{
                                    margin-bottom: 0;
                                }
                                &:nth-of-type(2){

                                }
                                a{
                                    padding: 0 16px;
                                    border-radius: 18px;
                                    display: block;
                                    height: 100%;
                                    overflow: hidden;
                                }
                                i{
                                    display: inline-block;
                                    float: left;
                                    color: #252525;
                                    font-size: 16px;
                                }
                                b{
                                    display: inline-block;
                                    float: right;
                                    width: 30px;
                                    height: 36px;
                                    background: url("./image/yy2.png") no-repeat center center;
                                    background-size: 100%;
                                    line-height: 36px;
                                }

                            }
                            .on{

                                a{
                                    background: #13AE67;
                                }
                                i{
                                    color: #FFFFFF;
                                }
                                b{
                                    background: url("./image/yy.png") no-repeat center center;
                                    background-size: 86%;
                                    transform:rotate(90deg);
                                }
                            }
                            .second{
                                li{
                                    a{
                                        text-indent: 20px;
                                        background: transparent;
                                        i{
                                            color: #252525;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    .rightContent{
                        float: right;
                        margin-left: 88px;
                        width: 866px;
                        .frameList{
                            margin-left: 66px;
                            li{
                                width: 655px;
                                height: 146px;
                                background: #FFFFFF;
                                border: 1px solid #37BA7E;
                                border-radius: 10px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                position: relative;
                                margin-bottom: 40px;
                                a{
                                    display: block;
                                }
                                &:after{
                                    content: ' ';
                                    width: 24px;
                                    height: 14px;
                                    background: url("./image/frame.png") no-repeat center center;
                                    background-size: 100%;
                                    display: block;
                                    position: absolute;
                                    bottom: -28px;
                                }
                                &:last-child{
                                    margin-bottom: 0;
                                    &:after{
                                        display: none;
                                    }
                                }
                                h4{
                                    width: 100%;
                                    font-size: 18px;
                                    color: #13AE67;
                                    line-height: 24px;
                                    height: 24px;
                                    text-align: center;
                                }
                                h5{
                                    width: 100%;
                                    font-size: 14px;
                                    color: #505050;
                                    line-height: 20px;
                                    height: 20px;
                                    text-align: center;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
